import styled from 'styled-components'

export const PracticeSubText = styled.span`
  font-size: 14px;
  line-height: 17px;
  color: #B1BFC5;
  margin: 0px;
  margin-top: 10px;
`
